import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class Button extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    preventDefault: PropTypes.bool,
    role: PropTypes.oneOf(['default', 'primary', 'danger', 'create', 'search'])
      .isRequired,
    size: PropTypes.oneOf(['', 'large', 'small']),
    tag: PropTypes.string.isRequired
  }

  static defaultProps = {
    role: 'default',
    preventDefault: true,
    disabled: false,
    tag: 'button'
  }

  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e) {
    const { onClick, preventDefault } = this.props
    if (preventDefault) {
      e.preventDefault()
    }

    onClick && onClick(e)
  }

  render() {
    let sizeClass

    const {
      children,
      className,
      role,
      size,
      onClick,
      preventDefault,
      tag: Component,
      ...attrs
    } = this.props

    if (size) {
      sizeClass = `qv-button-${size}`
    }

    const roleClass = `qv-button-${role}`
    const classes = classNames('qv-button', sizeClass, roleClass, className)

    return (
      <Component
        className={classes}
        onClick={this.handleClick}
        disabled={this.props.disabled}
        {...attrs}
      >
        {children}
      </Component>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/buttons/Button.js